export default function () {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <circle
        strokeWidth="3"
        strokeMiterlimit="10"
        stroke="#bc2027"
        fill="none"
        cx="50"
        cy="50"
        r="45.27"
      />
      <polyline
        strokeLinecap="round"
        strokeWidth="3"
        strokeMiterlimit="10"
        stroke="#bc2027"
        fill="none"
        points="29.98 59.01 50 38.99 70.02 59.01"
      />
    </svg>
  );
}
